<template>
    <transition name="component-fade">
        <section v-if="isActive" class="overlay tariffs-overlay">
            <div class="overlay__inner">
                <header class="overlay__header">
                    <h3 class="overlay__headline">
                        {{ $t(`overlays.${type}.headline`) }}
                    </h3>
                    <button class="icon-btn close-btn" @click="closeOverlay()">
                        <svg class="icon" width="16px" height="16px">
                            <use xlink:href="#icon-x" />
                        </svg>
                    </button>
                </header>
                <div class="overlay__content">
                    <div class="tariff-table">
                        <table>
                            <thead>
                                <tr>
                                    <th class="service-header">{{ $t('overlays.tariffs.text.table-headline') }}</th>
                                    <th v-for="product in services" :key="product.title" :class="product.icon">
                                        <app-icon icon="wallet" class="is-block" size-px="64px" />
                                        <p class="is-block">
                                            {{ product.title }}
                                        </p>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(category, index) in serviceCategories"
                                    :key="category.name"
                                    :class="{ 'first-of-category': [0, 4, 9, 12].includes(index) }"
                                >
                                    <th width="50%" class="size-small" v-html="category.text" />
                                    <td
                                        v-for="(product, index) in services"
                                        :key="product.title"
                                        class="size-small"
                                        width="12.5%"
                                    >
                                        {{ service(index, category.name) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="small-text mt-1 mb-0 color-gray">
                        {{ $t('overlays.tariffs.text.notice') }}
                    </p>

                    <p class="small-text color-gray mt-1">
                        <small>{{ $t('overlays.tariffs.text.footnote-1') }}</small>
                        <!--
                        <br />
                        <small>{{ $t('overlays.tariffs.text.footnote-2') }}</small>
                        <br />
                        <small>{{ $t('overlays.tariffs.text.footnote-3') }}</small>
                        <br />
                        <small>{{ $t('overlays.tariffs.text.footnote-4') }}</small>
                        -->
                    </p>
                </div>
            </div>
        </section>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import Helpers from '@/helpers';
import AppIcon from '@/components/AppIcon.vue';
export default {
    components: { AppIcon },
    props: {
        type: {
            type: String,
            default: 'bankstatus',
        },
        isActive: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            serviceCategories: [
                // --- Buchungen
                { name: 'price_1', text: 'Kontoführung p.M. im Klassik-Status' },
                { name: 'price_2', text: 'Kontoführung p.M. im Silber-Status' },
                { name: 'price_3', text: 'Kontoführung p.M. im Gold-Status' },
                { name: 'price_4', text: 'Kontoführung p.M. im Platin-Status' },
                // --- Buchungen
                { name: 'booking_1', text: 'Überweisung per Online-Banking' },
                { name: 'booking_2', text: 'Gutschrift Lastschrift' },
                { name: 'booking_3', text: 'Echtzeitüberweisung' },
                { name: 'booking_4', text: 'Beleghafte / telefonische Überweisung' },
                {
                    name: 'booking_5',
                    text: 'Bargeldeinzahlungen / auszahlungen an unseren Geldautomaten mit unserer Debitkarte¹',
                },
                // --- Karte
                { name: 'card_1', text: 'girocard - Ausgabe einer Debitkarte - p.a.' },
                { name: 'card_4', text: 'Digitale girocard - Ausgabe einer Debitkarte - p.a.' },
                { name: 'card_2', text: 'PSD Visa Card - Ausgabe einer Kreditkarte - p.a.' },
                { name: 'card_3', text: 'PSD Visa GoldCard - Ausgabe einer Kreditkarte - p.a.' },
            ],
            services: [
                {
                    title: 'PSD GiroPremium',
                    //
                    price_1: 9.9,
                    price_2: 7.4,
                    price_3: 6.4,
                    price_4: 4.9,
                    //
                    booking_1: true,
                    booking_2: true,
                    booking_3: true,
                    booking_4: true,
                    booking_5: true,
                    //
                    card_1: true,
                    card_4: true,
                    card_2: 25,
                    card_3: 70,
                },
                {
                    title: 'PSD GiroKomfort',
                    //
                    price_1: 4.9,
                    price_2: 2.4,
                    price_3: 1.4,
                    price_4: 0.0,
                    //
                    booking_1: true,
                    booking_2: true,
                    booking_3: 0.5,
                    booking_4: 2.0,
                    booking_5: true,
                    //
                    card_1: 9.0,
                    card_4: true,
                    card_2: 25.0,
                    card_3: 70.0,
                },
                {
                    title: 'PSD GiroBasic',
                    //
                    price_1: 3.4,
                    price_2: 0.9,
                    price_3: 0.0,
                    price_4: 0.0,
                    //
                    booking_1: 0.3,
                    booking_2: 0.3,
                    booking_3: 0.5,
                    booking_4: 3.0,
                    booking_5: true,
                    //
                    card_1: 9.0,
                    card_4: true,
                    card_2: 25.0,
                    card_3: 70.0,
                },
            ],
        };
    },
    computed: {
        ...mapGetters(['getAppModules']),
        service() {
            return (tariff, category) => {
                const content = this.services[tariff][category];

                if (typeof content === 'boolean') {
                    return content === true ? '✓' : 'x';
                }
                if (typeof content === 'number') {
                    return Helpers.formatNumberAsEuro(content);
                }
                if (typeof content === 'string') {
                    return content;
                }
            };
        },
    },
    methods: {
        closeOverlay() {
            this.$store.commit('UPDATE_VIEW', {
                view: `${this.type}Overlay`,
                payload: false,
            });
        },
        keyListeners: function(e) {
            // Listen to ESC key
            if (e.keyCode === 27) {
                this.closeOverlay();
            }
        },
    },
    watch: {
        isActive(newValue) {
            if (newValue === true) {
                document.addEventListener('keyup', this.keyListeners);
            } else {
                document.removeEventListener('keyup', this.keyListeners);
            }
        },
    },
};
</script>
